export const formatStringArray = (arr: string[]) => {
  return arr
    .map((e, index) => `${e}${index < arr.length - 1 ? ', ' : ''}`)
    .join('');
};
